export default function Hero() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 right-10 w-72 h-72 rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              热门吃瓜
            </span>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              五一吃瓜网
              <span className="block text-primary-500">最新最全的娱乐八卦资讯平台</span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-foreground-600 mb-6">
              吃瓜第一线，精彩不错过
            </p>

            <p className="text-foreground-700 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              五一吃瓜网每日追踪娱乐圈最新动态，从明星八卦到综艺内幕，从网红热点到影视资讯，为你提供全方位、多维度的吃瓜体验。平台聚合海量优质内容，实时更新热门话题，让你随时随地掌握第一手娱乐情报。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-accent-500">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新话题</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-accent-500">24h</div>
                <div className="text-xs text-foreground-500 mt-1">全天候滚动更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-accent-500">100+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖内容分类</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#topics')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                浏览热门话题
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => handleScroll('#about')}
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300 text-foreground-700 font-medium text-sm rounded-full hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解平台
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=An%20artistic%20editorial%20collage%20featuring%20abstract%20news%20and%20entertainment%20media%20elements%2C%20with%20warm%20amber%20and%20coral%20tones%2C%20dramatic%20lighting%20from%20upper%20left%2C%20magazine-style%20layout%20with%20subtle%20headline%20textures%2C%20modern%20digital%20media%20composition%2C%20clean%20sophisticated%20aesthetic%2C%20soft%20gradient%20background%20with%20geometric%20overlays&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="五一吃瓜网 — 娱乐八卦资讯平台主视觉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}